import { render, staticRenderFns } from "./ListPayService.vue?vue&type=template&id=506ceb59&scoped=true&"
import script from "./ListPayService.vue?vue&type=script&lang=ts&"
export * from "./ListPayService.vue?vue&type=script&lang=ts&"
import style0 from "./ListPayService.vue?vue&type=style&index=0&id=506ceb59&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../boss_taobao/client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "506ceb59",
  null
  
)

export default component.exports